export enum LegalRiskState {
  FORBIDEN = "forbiden",
  APPROVED = "approved",
  REJECTED = "rejected",
  NONE = "none"
}
